import { React, useEffect, useState } from "react";
import { Col, Offcanvas, Stack } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { BsPower } from "react-icons/bs";
import { MdOutlineFlight } from "react-icons/md";

import { FcPlus } from "react-icons/fc";
import hlogo from "../../images/hlogo.png";

import { connect } from "react-redux";
import { HiOutlineHome } from "react-icons/hi";
import { get_user } from "../../actions/myuser";
import { logout } from "../../actions/auth";
import { FaUsers } from "react-icons/fa";
import { IoTicketOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
function SmallSideBar({ user, logout }) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const toggleShow = () => setShow((s) => !s);

  const navigate = useNavigate();
  useEffect(() => {
    get_user();
  }, []);
  return (
    <>
      <div className="projectsidebar">
        <nav>
          <Stack direction="horizontal" className="smallsidebar ">
            <NavLink className="smallsidebarnavanchor" to={"/ticketing/home"}>
              <Stack gap={2}>
                <div className="ps-1 pt-2 d-flex justify-content-center">
                  <HiOutlineHome className="smallsidebaricon" size={20} />
                </div>
                <p className="single-line smallsidebartext text-center">Home</p>
              </Stack>
            </NavLink>
            <NavLink
              to={"/ticketing/tickets"}
              className="smallsidebarnavanchor">
              <Stack gap={2}>
                <div className="ps-1 pt-2 d-flex justify-content-center">
                  <IoTicketOutline className="smallsidebaricon" size={20} />
                </div>
                <p className="single-line smallsidebartext text-center">
                  Tickets
                </p>
              </Stack>
            </NavLink>
            <NavLink className="smallsidebarbutton">
              <FcPlus
                onClick={toggleShow}
                className={
                  show
                    ? "sidebarbutton sidebarbuttonanimated mx-auto"
                    : "sidebarbutton mx-auto"
                }
              />
            </NavLink>
            <NavLink
              to={"/ticketing/flights"}
              className="smallsidebarnavanchor">
              <Stack gap={2}>
                <div className="ps-1 pt-2 d-flex justify-content-center">
                  <MdOutlineFlight className="smallsidebaricon" size={20} />
                </div>
                <p className="single-line smallsidebartext text-center">
                  Flights
                </p>
              </Stack>
            </NavLink>
            <NavLink
              to={"/ticketing/clients"}
              className="smallsidebarnavanchor">
              <Stack gap={2}>
                <div className="ps-1 pt-2 d-flex justify-content-center">
                  <FaUsers className="smallsidebaricon" size={20} />
                </div>
                <p className="single-line smallsidebartext text-center">
                  Clients
                </p>
              </Stack>
            </NavLink>
          </Stack>
        </nav>
      </div>
      <Col
        className="d-lg-none d-flex align-items-center justify-content-center"
        sm={12}>
        <Offcanvas show={show} onHide={handleClose} className="myoffcanvas">
          <Offcanvas.Header className="m-0 p-3 ps-4">
            <Offcanvas.Title>
              <img
                src={hlogo}
                alt="smalllogo"
                id="logosmall"
                style={{ width: "80%" }}
              />
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body className="offcanvascolumn pb-3">
            <nav>
              <NavLink
                to={"/ticketing/home"}
                className="navanchor mt-1"
                onClick={handleClose}>
                <HiOutlineHome className="icon" />
                DashBoard
              </NavLink>
              <NavLink
                to={"/ticketing/tickets"}
                className="navanchor"
                onClick={handleClose}>
                <IoTicketOutline className="icon" />
                Tickets
              </NavLink>
              <NavLink
                to={"/ticketing/flights"}
                className="navanchor"
                onClick={handleClose}>
                <MdOutlineFlight className="icon" />
                Flights
              </NavLink>
              <NavLink
                to={"/ticketing/clients"}
                className="navanchor"
                onClick={handleClose}>
                <FaUsers className="icon" />
                Clients
              </NavLink>
            </nav>
          </Offcanvas.Body>
          <div
            className="d-flex justify-content-center"
            style={{ backgroundColor: "#3d3c3c" }}>
            <button
              className="btn btn-sm btn-light w-50 logoutbutton"
              onClick={() => {
                logout().then(() => {
                  navigate("/");
                });
              }}>
              <BsPower className="icon" size={23} color="black" />
              Logout
            </button>
          </div>
        </Offcanvas>
      </Col>
    </>
  );
}

const mapStateToProps = (state) => ({
  user: state.current_user.user,
});
export default connect(mapStateToProps, { get_user, logout })(SmallSideBar);
